import { ChargifyState } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_payment_pb";

export const chargifyStateDisplayMapping = {
  [ChargifyState.UNSPECIFIED]: "Unspecified",
  [ChargifyState.ACTIVE]: "Active",
  [ChargifyState.TRIALING]: "Trialing",
  [ChargifyState.PAST_DUE]: "Past Due",
  [ChargifyState.CANCELED]: "Canceled",
};

export const PricePointChanges = {
  ENTERPRISE_TO_PREMIUM: "enterprise_to_premium",
  PREMIUM_TO_ENTERPRISE: "premium_to_enterprise",
};
